<template>
	<nav class="container">
		<div class="row no-gutters text-center">
			<div class="primary-links pb-2 mb-2 px-0">
				<div class="text-nowrap overflow-auto px-2 py-1">
					<div v-for="people in peopleList" class="position-relative d-inline-block px-1" :key="people.id">
						<a :href="`people/chat?id=${people._id.wpId}`" class="btn ps-2 pe-3 d-flex align-items-center" :class="people._id.active ? 'btn-primary text-light border-primary' : 'btn-light text-dark border-dark'">
							<div class="avatar avatar--mini flex-shrink-0 me-1" :style="{ backgroundImage: `url(${people._id.avatar})` }"></div>
							<span v-if="people.online" class="online-badge"></span>
							{{ people._id.firstName }} {{ people._id.lastName }}
							<span v-if="people._id.unreadMessage > 0" class="badge mx-1" :class="people._id.active ? 'bg-info' : 'bg-primary'">{{ people._id.unreadMessage }}</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script lang="ts">
import { defineComponent, } from 'vue'
import type { PropType } from 'vue'

type Person = {
	_id: {
		wpId: number,
		url: string,
		avatar: string,
		name: string,
		active: boolean,
		unreadMessage: number
		firstName: string,
		lastName: string
	}
}

export default defineComponent({
	name: 'ChatPeopleBar',
	props: {
		peopleList: {
			type: Array as PropType<Person[]>,
			required: true
		}
	},
	components: {
		// HelloWorld
	},
	data(){
		return {};
	}
})
</script>
